export class Advert {

    public image_url: string;

    public static createOne(data: any): Advert {

        data = data[Math.floor(Math.random() * data.length)];

        let advert = new Advert();
        advert.fill(data);
        return advert;
    }

    public fill(data: any) {
        if(typeof data !== 'undefined') {
            this.image_url = data.image_url || null;
        } else {
            this.image_url = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/models/advert.ts